<template>
  <v-app> 
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {  
  },
  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');
.v-application--wrap {
	min-height: calc(var(--vh, 1vh) * 100) !important;
}
</style>